import React from 'react';
import TitleAbout from '../../components/Title';
import Photo from './pictures/profile.jpg';
import PhotoTwo from './pictures/profile_2.jpg';
import { FaAward, FaBookmark, FaCheckDouble } from 'react-icons/fa';
import './sobre.scss';
import Ouvidoria from '../../components/Ouvidoria';
import SEO from '../../SEO/SEO';


export default function Sobre(link2){

  return(
    <>
    <SEO title='Sobre - Séculos Engenharia e Serviços LTDA' link='https://seculosengenharia.com.br/sobre' />
      <div>

        <TitleAbout name="Sobre a Séculos" link1={"Home / "} link2="Sobre">
        </TitleAbout>

        <section id='desc-about'>
          <div className='container'>
            <div className="desc-about">
              <div className='box-desc'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
              >
                <img className='img-fluid' src={Photo} width="650" alt="img-about-enterprise"/>
              </div>
              <div className='box-desc'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <h2>
                Sobre nós
                </h2>
                <p>A SÉCULOS ENGENHARIA E SERVIÇOS LTDA, uma empresa genuinamente paraense, foi fundada, em 25 de janeiro de 1995, na cidade de Belém. Posteriormente transferiu sua sede para a cidade de Parauapebas-PA, em 25 de fevereiro de 2000, onde passou a exercer suas atividades na região do Complexo Minerador de Carajás no Pará.</p>
                <p>A Séculos é uma empresa focada na qualidade, segurança, respeito, ética, responsabilidade e sustentabilidade na prestação de serviços aos seus clientes.</p>
              </div>
            </div>
          </div>
        </section>

        <section id='values'>
          <div className='container'>
            <div className="row-values">
              <div className="box-values" 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
              >
                  <FaAward size={70} />
                  <h4>Nossa Visão</h4>
                  <p>Ser lider no mercado de serviços, destacando-se pelo compromisso com desenvolvimento sustetável.
                  </p>
              </div>
              <div className="box-values"
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <FaCheckDouble size={70} />
                <h4>Missão</h4>
                <p>Atender com excelência, gerando empregos, oportunidades e contribuindo para inclusão social e qualidade de vida.
                </p>
              </div>
              <div className="box-values"
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <FaBookmark size={70} />
                <h4>Valores</h4>
                <p>
                  1. Respeito às leis e regulamentações <br/>
                  2. Responsabilidade socioeconômica e ambiental <br/>
                  3. Integridade com todos os públicos <br/>
                  4. Humildade<br/>
                  5. Valorização dos colaboradores <br/>
                  6. Compromisso com clientes e fornecedores <br/>
                </p>
              </div>
            </div>
          </div>
        </section>
        
        {/* Profiles Section */}
        <section id='professionals'>
          <div className='container'>
            <div className='professionals'>
              <div className='img-about'>
                <h3
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >
                  Nosso time de profissionais
                </h3>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >A SÉCULOS ENGENHARIA E SERVIÇOS LTDA possui uma equipe de profissionais qualificados, metodologias e processos testados e otimizados para desenvolver serviços de qualidade e de fácil gestão para o cliente. Alguns de nossos diferenciais:
                </p>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >● Buscamos a melhoria contínua através de parcerias estratégicas e investimentos na qualificação dos nossos colaboradores;</p>
                
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >● Identificamos as mais avançadas possibilidades tecnológicas, assegurando que nossos serviços estejam alinhados às últimas tendências do mercado e às necessidades dos nossos clientes;
                </p>

                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >● Possuímos uma equipe altamente qualificada para prestar atendimento diferenciado aos nossos clientes;</p>

                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 >● Comprometimento com a ética nos relacionamentos interpessoais.</p>
              </div>

              <div className="img-about">
                <img src={PhotoTwo} className="img-fluid" width={650} alt="section photos"
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                 />
              </div>
            </div>
          </div>
        </section>

        {/* Section Ouvidoria */}
        <Ouvidoria/>
      </div>
    </>
  )
}  


